import extensions from './extensions';
import viewports from './viewports';

const reducers = { extensions, viewports };

export default reducers;
